/* unplugin-vue-components disabled */import { render } from "./FeedbackBox.vue?vue&type=template&id=e8a2cdc0&scoped=true&lang=pug"
import script from "./FeedbackBox.vue?vue&type=script&setup=true&lang=js"
export * from "./FeedbackBox.vue?vue&type=script&setup=true&lang=js"

import "./FeedbackBox.vue?vue&type=style&index=0&id=e8a2cdc0&lang=stylus&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8a2cdc0"]])

export default __exports__